import PropTypes from "prop-types";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { MdOutlineCheck, MdAdd, MdClose } from "react-icons/md";
import SpeedDialCM from "../SpeedDial";
import {
  SpeedDialWrapper,
  StyledDateTypo,
  StyledPhoneTypo,
  StyledTableToobar,
  ToolbarBox,
} from "./Table.style";
import { Box } from "@mui/system";
import ImgContainer from "../Image";
import logo from "assets/img/logo.png";
import { StyledLink } from "../Link";

const EnhancedTableToolbar = (props) => {
  const { numSelected, factorInfo } = props;

  return (
    <StyledTableToobar
      $numSelected={numSelected > 0}
      style={{ overflowX: "auto" }}
      $minHeight={props.title}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} مورد انتخاب شد
        </Typography>
      ) : props.factor ? (
        <ToolbarBox id="tableTitle">
          <Box style={{ width: "max-content" }}>
            <Typography fontSize={18} color="secondary.dark">
              شماره سفارش: {factorInfo.orderId}
            </Typography>
            <Typography fontSize={18} color="secondary.dark" mt={1}>
              بنام: {factorInfo.userName}
            </Typography>
          </Box>

          <ImgContainer src={logo} width={150} my={2} ml={2} mr={2} />

          <Box style={{ width: "max-content" }}>
            <StyledDateTypo
              variant="span"
              component="div"
              color="secondary.dark"
            >
              <span style={{ direction: "ltr" }}>{factorInfo.date}</span>
              <Typography
                variant="span"
                color="secondary.dark"
                fontSize={18}
                px={0.5}
              >
                :تاریخ
              </Typography>
            </StyledDateTypo>

            <StyledPhoneTypo
              variant="span"
              component="div"
              color="secondary.dark"
              mt={1}
            >
              {factorInfo.phone}
              <Typography
                variant="span"
                color="secondary.dark"
                fontSize={18}
                px={0.5}
              >
                :همراه
              </Typography>
            </StyledPhoneTypo>
          </Box>
        </ToolbarBox>
      ) : (
        <ToolbarBox id="tableTitle">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            color="secondary.dark"
          >
            {props.title}
          </Typography>
        </ToolbarBox>
      )}

      {numSelected > 0 ? (
        <>
          {props.onDelete && (
            <Tooltip title="لغو" arrow>
              <IconButton onClick={props.onDelete}>
                <MdClose />
              </IconButton>
            </Tooltip>
          )}
          {props.onSubmit && (
            <Tooltip title="تایید" arrow>
              <IconButton onClick={props.onSubmit}>
                <MdOutlineCheck />
              </IconButton>
            </Tooltip>
          )}
        </>
      ) : (
        (props.filterDate || props.filterBread) && (
          <SpeedDialWrapper>
            <SpeedDialCM
              filterDate={(e) => props.filterDate(e)}
              filterBread={(e) => props.filterBread(e)}
              isDateFiltred={props.isDateFiltred}
              isBreadFiltred={props.isBreadFiltred}
            />
          </SpeedDialWrapper>
        )
      )}
      {props.addAttendance && (
        <StyledLink to={`/teacher_class/${props.addAttendance}/attendance/add`}>
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            حضور و غیاب جدید
          </Button>
        </StyledLink>
      )}
      {props.addProduct && (
        <StyledLink to="/products/add">
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            محصول جدید
          </Button>
        </StyledLink>
      )}

      {props.addDiscount && (
        <StyledLink to="/discount/add">
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            ثبت کد تخفیف
          </Button>
        </StyledLink>
      )}
      {props.addUser && (
        <StyledLink to="/user/add">
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            افزودن کاربر
          </Button>
        </StyledLink>
      )}
      {props.addExcellScore && (
        <StyledLink to="/teacher_scores_excell-file/add">
          <Button
            endIcon={<MdAdd />}
            variant="contained"
            mt={1}
            sx={{ width: "max-content", mr: 1 }}
          >
            افزودن
          </Button>
        </StyledLink>
      )}
      {props.addAdmin && (
        <StyledLink to="/admin/add">
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            ادمین جدید
          </Button>
        </StyledLink>
      )}
      {props.addBranch && (
        <StyledLink to="/branch/add">
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            شعبه جدید
          </Button>
        </StyledLink>
      )}
      {props.addQuestion && (
        <StyledLink to="/addquestion">
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            سوال جدید
          </Button>
        </StyledLink>
      )}
      {props.addHomeProduct && (
        <>
          <StyledLink to="/homeproducts/add">
            <Button endIcon={<MdAdd />} variant="contained" mt={1}>
              محصول جدید
            </Button>
          </StyledLink>
          <StyledLink to="/category" style={{ marginRight: "10px" }}>
            <Button variant="contained" mt={1}>
              سردسته ها
            </Button>
          </StyledLink>
        </>
      )}
      {props.addClassScore && (
        <StyledLink to={`/teacher_class/${props.addClassScore}/scores/add`}>
          <Button endIcon={<MdAdd />} variant="contained" mt={1}>
            افزودن
          </Button>
        </StyledLink>
      )}
    </StyledTableToobar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  factorInfo: PropTypes.object,
};

export default EnhancedTableToolbar;
